import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { profileData } from '../../../types/profile.type';
import apiService from '../../../services/api';
import { toast } from 'react-toastify';

interface ProfileEditModalProps {
  open: boolean;
  onClose: () => void;
  userData: profileData;
}

const ProfileEditModal: React.FC<ProfileEditModalProps> = ({
  open,
  onClose,
  userData,
}) => {
  console.log('userData', userData);
  const [isEditing, setIsEditing] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<profileData>({
    defaultValues: userData,
  });

  const onSubmit = (data: profileData) => {
    console.log('Updated Data:', data);

    const finalData = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      phone: data?.phone,
    };
    apiService.updateProfile(finalData);
    toast.success('Profile updated sucessfully');
    setIsEditing(false);
    onClose();
  };

  const handleCancel = () => {
    reset(userData);
    setIsEditing(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={600}>
            Profile
          </Typography>

          {!isEditing && (
            <Button variant="contained" onClick={() => setIsEditing(true)}>
              Edit
            </Button>
          )}
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <form id="profileForm" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            {/* EMAIL */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                fullWidth
                disabled
                {...register('email')}
              />
            </Grid>

            {/* PHONE */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Contact Number"
                fullWidth
                disabled={!isEditing}
                {...register('phone', {
                  required: 'Contact Number is required',
                })}
                error={!!errors.phone}
                helperText={errors.phone?.message}
              />
            </Grid>

            {/* FIRST NAME */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="First Name"
                fullWidth
                disabled={!isEditing}
                {...register('firstName', {
                  required: 'First Name is required',
                  minLength: { value: 2, message: 'Min 2 characters' },
                })}
                error={!!errors.firstName}
                helperText={errors.firstName?.message}
              />
            </Grid>

            {/* LAST NAME */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Last Name"
                fullWidth
                disabled={!isEditing}
                {...register('lastName', {
                  required: 'Last Name is required',
                  minLength: { value: 2, message: 'Min 2 characters' },
                })}
                error={!!errors.lastName}
                helperText={errors.lastName?.message}
              />
            </Grid>

            {/* ROLE */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Role"
                fullWidth
                disabled
                value={
                  typeof userData.role === 'object'
                    ? userData.role.name
                    : userData.role
                }
                // {...register("role")}
              />
            </Grid>

            {/* EMAIL VERIFIED */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email Verified"
                fullWidth
                disabled
                value={userData.isEmailVerified ? 'Yes' : 'No'}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>

      <DialogActions>
        {isEditing ? (
          <>
            <Button variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="contained" type="submit" form="profileForm">
              Update
            </Button>
          </>
        ) : (
          <Button
            onClick={onClose}
            variant="outlined"
            color="inherit"
            sx={{
              backgroundColor: 'rgba(211, 47, 47, 0.08)',
              color: '#d32f2f',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: 'rgba(211, 47, 47, 0.15)',
              },
            }}
          >
            Cancel
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ProfileEditModal;
